<template>
  <div class="slide" id="slide_before_results" v-show="isVisibleSlide('before_results')">
    <!-- Variant 1 -->
    <div class="slide-content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="content-wrapper">
              <!-- Variant 1 -->
              <div>
                <p>While we check your answers...</p>
                <p>
                  <strong>First aid incidents should be a rarity at work, but for McDonald’s workers it’s a regular occurrence. Staff say even serious burns are treated as ‘part and parcel’ of the job.</strong>
                </p>
                <p>At Megaphone, we’re helping McDonald’s workers fight back and demand safer workplaces - as well as supporting thousands of other UK workers who face dangerous environments, poor treatment and bullying. <strong>But we need your support.</strong></p>
                <p class="highlight">Do you agree that everyone deserves safe working conditions and to be treated with respect? If so, add your name:</p>
              </div>
              <div>
                <div class="buttons-container">
                  <button
                    class="btn btn-light red"
                    @click="gotoSlide('petition'); analytics('before results', 'clicked yes');"
                  >YES, OF COURSE</button>
                  <button
                    class="btn btn-light"
                    @click="gotoSlide('results'); analytics('before results', 'clicked no');"
                  >No, sorry</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BeforeResults",
  props: ["gotoSlide", "isVisibleSlide", "analytics"],
  data() {
    return {
      showButtons: false
    };
  },
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
.slide-content {
  .container {
    box-shadow: 0px 0px 10px rgba(70, 70, 70, 0.1);
    text-align: center;
    @media only screen and (max-width: 768px) {
      box-shadow: none;
    }
    .content-wrapper {
      margin: 100px auto 100px auto;
      max-width: 650px;
      min-height: 400px;
      @media only screen and (max-width: 1100px) {
        margin: 60px auto 60px auto;
      }
      @media only screen and (max-width: 768px) {
        margin: 30px auto;
      }
    }
  }
  &.variant2 {
    .container {
      box-shadow: none;
      .content-wrapper {
      }
    }
  }
  p {
    font-size: 17px;
    text-align: left;
    &.highlight {
      color: #cd171e;
      font-weight: 600;
      margin-top: 40px;
    }
    @media only screen and (max-width: 768px) {
      // text-align: center;
      font-size: 14px;
    }
  }
}
.buttons-container {
  margin-top: 30px;
  @media only screen and (max-width: 768px) {
    text-align: center;
  }
  button {
    display: inline-block;
    margin: 0 10px;
    font-size: 17px;
    min-width: 230px;
    padding: 17px 35px;
    @media only screen and (max-width: 768px) {
      margin: 0 0 15px 0;
      max-width: 400px;
      width: 100%;
    }
  }
}
.btn-skip {
  margin-top: 40px;
  @media only screen and (max-width: 768px) {
    margin-top: 10px;
  }
}
</style>
